var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddICon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#7B68EE",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2857 12.8571C19.2857 12.3821 18.9036 12 18.4286 12C17.9536 12 17.5714 12.3821 17.5714 12.8571V18.5714H11.8571C11.3821 18.5714 11 18.9536 11 19.4286C11 19.9036 11.3821 20.2857 11.8571 20.2857H17.5714V26C17.5714 26.475 17.9536 26.8571 18.4286 26.8571C18.9036 26.8571 19.2857 26.475 19.2857 26V20.2857H25C25.475 20.2857 25.8571 19.9036 25.8571 19.4286C25.8571 18.9536 25.475 18.5714 25 18.5714H19.2857V12.8571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddICon);
export default __webpack_public_path__ + "static/media/AddICon.992a033dda953b695071c98b7b159482.svg";
export { ForwardRef as ReactComponent };